import { NavLink } from "react-router-dom";
import { X } from "lucide-react";

import { IconButton, cn, focusRing } from "../../components/ui";
import { SUPPLIER_NAV_ITEMS } from "../navigation/supplierNavigation";
import { useSupplierAuth } from "../context/SupplierAuthContext";

const row = "flex min-h-8 items-center gap-2.5 rounded-control px-2 text-body-sm transition-colors duration-150 max-md:min-h-touch";

const linkClass = ({ isActive }) =>
  cn(
    row,
    focusRing,
    isActive
      ? "bg-accent-subtle font-medium text-accent"
      : "text-secondary hover:bg-hover hover:text-foreground"
  );

export default function SupplierSidebar({ onNavigate, onClose }) {
  const { suppliers } = useSupplierAuth();
  const supplierName = suppliers?.[0]?.name || "Supplier";

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="flex h-[var(--layout-topbar)] shrink-0 items-center gap-2 border-b border-subtle px-4">
        <div className="min-w-0 flex-1">
          <div className="truncate text-panel-title text-foreground">{supplierName}</div>
          <div className="text-meta text-tertiary">Supplier Portal</div>
        </div>
        {onClose ? (
          <IconButton icon={X} label="Close menu" size="sm" onClick={onClose} className="-mr-2" />
        ) : null}
      </div>

      <nav
        className="flex min-h-0 flex-1 flex-col gap-px overflow-y-auto px-2 py-3 scrollbar-fade"
        aria-label="Supplier navigation"
      >
        {SUPPLIER_NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={linkClass}
              onClick={onNavigate}
            >
              <Icon className="h-4 w-4 shrink-0" aria-hidden="true" />
              <span className="truncate">{item.label}</span>
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}
